import config from 'config';

const LOAD = 'horse-racing/jockeyProfile/LOAD';
const LOAD_SUCCESS = 'horse-racing/jockeyProfile/LOAD_SUCCESS';
const LOAD_FAIL = 'horse-racing/jockeyProfile/LOAD_FAIL';
const LOAD_RESET = 'horse-racing/jockeyProfile/LOAD_RESET';

const initialState = {
  profile: {}
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD:
      return {
        ...state,
        loading: true
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        profile: action.result
      };
    case LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      };
    case LOAD_RESET:
      return {
        ...state,
        loading: false,
        loaded: false
      };
    default:
      return state;
  }
}

export function isProfileLoaded({ horseRacing: { jockeyProfile: { loading, loaded } } }) {
  return (loading || loaded);
}

export function resetProfileLoaded() {
  return { type: LOAD_RESET }
}

export function load(jockeyId) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: client => client.get(`${config.api.horseRacing.jockey}/${jockeyId}`)
  };
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/reducers/jockeyProfile.js